import gql from 'graphql-tag';

export const emailMonLog = gql`
  mutation emailMonLog($input: EmailRequest!) {
    emailMonLog(input: $input) {
      result
    }
  }
`;
